import PropTypes from 'prop-types'
import {Button as ReactStrapButton} from "reactstrap"

export default function Button({children, className, type, ...props}) {
  return (
    <ReactStrapButton type={type? type : "button" } className={`${className ? className : ''}`} {...props}>
      {children}
    </ReactStrapButton>
  )
}

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string,
  type: PropTypes.string
}